import React from 'react';

import SwipeHandler from './SwipeHandler';

const injectSwipeHandler = ({
    onSwipeLeft,
    onSwipeRight,
    onSwipeUp,
    onSwipeDown,
}) => WrappedComponent => {
    return class SwipeHandlingWrapper extends React.PureComponent {
        render() {
            return (
                <SwipeHandler
                    onSwipeDown={onSwipeDown}
                    onSwipeLeft={onSwipeLeft}
                    onSwipeRight={onSwipeRight}
                    onSwipeUp={onSwipeUp}
                >
                    <WrappedComponent {...this.props} />
                </SwipeHandler>
            );
        }
    };
};

export default injectSwipeHandler;
